// extracted by mini-css-extract-plugin
export default {"imgContainer":"BrandPartners_imgContainer__yfg4Y","lgImg":"BrandPartners_lgImg__gwaUY","brandContainer":"BrandPartners_brandContainer__6X9WL"};